import React, { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { openProfile } from '../lib/nav';
import Avatar from './Avatar';

/* Connection requests and introductions waiting on you, answerable right here.
   Mutual connections are the reason to trust one; without any, B/N's own
   reason for the introduction says why. Hidden when nothing is waiting. */
const SHOWN = 3;

export default function ConnectionRequestsCard({ refresh, onGo, notify }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState('');
  const load = useCallback(() => api.proposals().then(setRows).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load, refresh]);

  async function decide(p, decision) {
    setBusy(`${p.id}:${decision}`);
    try {
      const r = await api.decideProposal(p.id, decision);
      const first = p.other.name.split(' ')[0];
      if (decision === 'accept') notify?.(r.connected ? `You're connected with ${first}` : `You said yes — if ${first} does too, you're connected`);
      setRows((xs) => xs.filter((x) => x.id !== p.id));
    } catch (e) { notify?.(e.message); } finally { setBusy(''); }
  }

  if (!rows.length) return null;
  return (
    <section className="card rail-card" aria-label="Connection requests">
      <button type="button" className="rail-head" onClick={() => onGo('people')}>
        <span>Connection Requests ({rows.length})</span>
        <span className="rail-chev" aria-hidden="true">›</span>
      </button>
      {rows.slice(0, SHOWN).map((p) => (
        <div key={p.id} className="cr-item">
          <button type="button" className="cr-av" aria-label={`${p.other.name}'s profile`} onClick={() => openProfile(p.other.handle)}>
            <Avatar person={p.other} className="cr-avatar" />
          </button>
          <div className="cr-body">
            <button type="button" className="cr-name" onClick={() => openProfile(p.other.handle)}>{p.other.name}</button>
            {p.other.headline && <span className="cr-line">{p.other.headline}</span>}
            <span className="cr-line">
              {p.mutual > 0 ? `${p.mutual} mutual connection${p.mutual === 1 ? '' : 's'}`
                : p.basis === 'ask' ? 'Asked to connect' : 'Introduced by B/N'}
            </span>
            <div className="cr-actions">
              <button type="button" className="btn-gold" disabled={!!busy} onClick={() => decide(p, 'accept')}>
                {busy === `${p.id}:accept` ? '…' : 'Accept'}
              </button>
              <button type="button" className="btn-outline" disabled={!!busy} onClick={() => decide(p, 'decline')}>
                {busy === `${p.id}:decline` ? '…' : 'Decline'}
              </button>
            </div>
          </div>
        </div>
      ))}
      {rows.length > SHOWN && (
        <button type="button" className="rail-more" onClick={() => onGo('people')}>See all {rows.length}</button>
      )}
    </section>
  );
}
